import { PlusOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useImmer } from 'use-immer'
import {
  Button,
  ContentBody,
  OpportunityForm,
  Table,
  useAuthContext
} from '../../../../core/components'
import { Pagination } from '../../../../entities'
import { Product } from '../../../../entities/product'
import useOpportunityCreate from '../../../../services/mutations/useOpportunityCreate'
import useOrderCreate from '../../../../services/mutations/useOrderCreate'
import useCustomerOpportunities from '../../../../services/queries/customer/useCustomerOpportunities'
import { dateTimeFormat } from '../../../../utils/format/dateTimeFormat'

const opportunityDefaultValue = {
  businessUnityId: '',
  customerId: '',
  sellerId: '',
  marketId: '',
  situationId: '10',
  contacterId: '',
  contact: '',
  status: 'E',
  nextContact: '',
  salesForecast: '',
  proposalValidity: '',
  eventId: '',
  conceptId: '',
  orderId: ''
  // campaignId: ''
}

const orderDefaultValues = {
  customerId: '',
  salesmanId: '',
  paymentMethodId: '',
  paymentTermId: '',
  budgetId: '',
  businessUnitId: '',
  shippingType: '0',
  statusId: '10',
  invoiceType: 'N',
  total: '',
  approved: 0,
  canceled: 0,
  observation: '',
  deliveryDate: '',
  approvedDate: '',
  items: []
}

const formDefaultValues = {
  opportunity: opportunityDefaultValue,
  order: orderDefaultValues,
  temp: { address: '' }
}

const columns = [
  {
    title: 'Nº Oportunidade',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Evento (Origem do Contato)',
    dataIndex: 'event',
    key: 'event',
    render: (value: any) => {
      return value.name
    }
  },
  // {
  //   title: 'Campanha',
  //   dataIndex: 'campaign',
  //   key: 'campaign',
  //   render: (value: any) => {
  //     return value.name
  //   }
  // },
  {
    title: 'Conceito',
    dataIndex: 'concept',
    key: 'concept',
    render: (value: any) => {
      return value.name
    }
  },
  {
    title: 'Previsão da Venda',
    dataIndex: 'salesForecast',
    key: 'salesForecast',
    render: (value: any) => (value ? dateTimeFormat(value) : null)
  },
  {
    title: 'Situação',
    dataIndex: 'situation',
    key: 'situation'
  },
  {
    title: 'Data/Hora',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (value: any) => (value ? dateTimeFormat(value) : null)
  }
]

export const OpportunitiesTab = () => {
  const { goBack } = useHistory()

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [formValues, setFormValues] = useImmer(formDefaultValues)
  const { user } = useAuthContext()

  const {
    mutateAsync: orderMutate,
    data: orderResponse,
    reset: orderReset
  } = useOrderCreate()
  const { mutateAsync: opportunityMutate } = useOpportunityCreate()

  const { id }: any = useParams()
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const { data, error, isLoading }: any = useCustomerOpportunities({
    ...pagination,
    id
  })
  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  useEffect(() => {
    setFormValues((draft) => {
      draft.opportunity.customerId = id
    })
    console.log(data?.data?.customer?.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const handleSubmit = async () => {
    console.log(formValues)
    if (formValues.order.items.length > 0 && formValues.order.paymentMethodId) {
      const items = formValues.order.items.map(
        (item: Product, index: number) => ({
          ...item,
          sequence: index + 1,
          productId: item.id,
          quantity: 1,
          salePrice: item.price,
          defaultPrice: item.price,
          priceListId: '',
          discountPercent: 0
        })
      )
      const orderID = await orderMutate({
        ...formValues.order,
        items,
        salesmanId: user?.id || '',
        customerId: formValues.opportunity.customerId,
        total: formValues.order.items?.reduce(
          (acc: any, cur: any) => acc + cur.price,
          0
        )
      })
      console.log({ orderResponse })
      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || '',
        orderId: orderID?.data || ''
      })
    } else {
      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || ''
      })
    }
    orderReset()
    goBack()
    setFormValues(formDefaultValues)
  }

  const handleOk = () => {
    handleSubmit()
    setIsModalVisible(false)
  }

  const handleReset = () => {
    const customer = formValues.opportunity.customerId
    const bu = formValues.opportunity.businessUnityId

    setFormValues(() => ({
      ...formDefaultValues,
      opportunity: { customerId: customer, businessUnityId: bu },
      order: { businessUnitId: bu }
    }))
  }

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
          Novo
        </Button>
        <Modal
          title="Nova Oportunidade"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          centered
          width={1000}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancelar
            </Button>,
            <Button key="reset" onClick={handleReset}>
              Reiniciar
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
              Adicionar
            </Button>
          ]}
        >
          <OpportunityForm values={formValues} setValues={setFormValues} />
        </Modal>
        <div style={{ height: 20 }} />
        <Table
          columns={columns}
          dataSource={data?.data}
          bordered
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
        />
      </ContentBody>
    </>
  )
}
